<template>
  <div class="Index">
    <div class="l-container">
      <div class="wrapper">

        <div class="category">
          <div class="category-btn" @click="all" v-ripple>ALL<i class="fa fa-fw fa-angle-down"></i></div>
          <div class="category-btn" @click="regist" v-ripple>登録<i class="fa fa-fw fa-angle-down"></i></div>
          <div class="category-btn" @click="list" v-ripple>リスト<i class="fa fa-fw fa-angle-down"></i></div>
          <div class="category-btn" @click="support" v-ripple>対応履歴<i class="fa fa-fw fa-angle-down"></i></div>
          <div class="category-btn" @click="pdf" v-ripple>PDF<i class="fa fa-fw fa-angle-down"></i></div>
          <div class="category-btn" @click="other" v-ripple>その他<i class="fa fa-fw fa-angle-down"></i></div>
          <div class="category-btn" @click="aggregate" v-ripple>集計<i class="fa fa-fw fa-angle-down"></i></div>
          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting' || user.type === 'mgr' || user.id === 377">
            <div class="category-btn" @click="keiri" v-ripple>経理<i class="fa fa-fw fa-angle-down"></i></div>
          </template>
        </div>

        <div class="tile-box">

          <transition name="demo">
            <div class="tile" v-if="state.regist">

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
                <a href="http://153.126.169.95/users/sign_up"><i class="fa fa-fw fa-plus" title="User登録"></i>
                  <span>ユーザー登録</span>
                  <p class="desc">ユーザー登録を行います。<br>MGR以上の権限で登録可能</p>
                </a>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/appointments/add"><i class="fa fa-fw fa-plus" title="AP登録"></i>
                  <span>AP登録</span>
                  <p class="desc">アポ登録画面です。家庭情報とは別です。<br>契約にならなければ家庭登録はしません。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/families/add"><i class="fa fa-fw fa-plus" title="家庭登録"></i>
                  <span>家庭登録</span>
                  <p class="desc">AP情報と紐付けて家庭情報を登録します。<br>個別のAP詳細画面からでも登録できます。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/students/add"><i class="fa fa-fw fa-plus" title="生徒登録"></i>
                  <span>生徒登録</span>
                  <p class="desc">家庭情報と紐付けて生徒情報を登録します。<br>個別の家庭詳細画面からでも登録できます。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/tutors/add"><i class="fa fa-fw fa-plus" title="先生登録"></i>
                  <span>先生登録</span>
                  <p class="desc">先生の登録画面です。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/agreements/add"><i class="fa fa-fw fa-plus" title="契約情報登録"></i>
                  <span>契約情報登録</span>
                  <p class="desc">契約情報の登録画面です。<br>契約情報は生徒ごとに登録します。</p>
                </router-link>
              </template>

            </div>
          </transition>

          <transition name="demo">
            <div class="tile" id="list" v-if="state.list">

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
                <router-link to="/users"><i class="fa fa-fw fa-file-text" title="ユーザーリスト"></i>
                  <span>ユーザーリスト</span>
                  <p class="desc">NEOの登録ユーザー一覧です。<br>MGR以上の権限で閲覧可能</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
                <router-link to="/advisors"><i class="fa fa-fw fa-group" title="アドバイザー"></i>
                  <span>アドバイザー</span>
                  <p class="desc">アドバイザーの一覧です。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/appointments"><i class="fa fa-fw fa-file-text" title="APリスト"></i>
                  <span>APリスト</span>
                  <p class="desc">アポの一覧です。<br>契約前の家庭はここで管理します。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.office_id === 1 || user.office_id === 4">
                <router-link to="/appointments2"><i class="fa fa-fw fa-file-text" title="APリストⅡ"></i>
                  <span>APリストⅡ</span>
                  <p class="desc"></p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/appointments/confirms"><i class="fa fa-fw fa-file-text" title="確認リスト"></i>
                  <span>確認リスト</span>
                  <p class="desc">前日確認用リストです。<br></p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/families"><i class="fa fa-fw fa-file-text" title="家庭リスト"></i>
                  <span>家庭リスト</span>
                  <p class="desc">家庭の一覧です。<br>契約前の家庭はここにはありません。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/students"><i class="fa fa-fw fa-file-text" title="生徒リスト"></i>
                  <span>生徒リスト</span>
                  <p class="desc">生徒の一覧です。<br>対応履歴は家庭と生徒で共有されます。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/tutors"><i class="fa fa-fw fa-file-text" title="先生リスト"></i>
                  <span>先生リスト</span>
                  <p class="desc">先生の一覧です。<br>探しをする為のレイアウトになっています。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/tutors2"><i class="fa fa-fw fa-file-text" title="先生リストⅡ"></i>
                  <span>先生リストⅡ</span>
                  <p class="desc"></p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/agreements"><i class="fa fa-fw fa-handshake-o" title="契約リスト"></i>
                  <span>契約リスト</span>
                  <p class="desc">契約の一覧です。<br>生徒の詳細からも閲覧、編集できます。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/tutor_channels"><i class="fa fa-fw fa-graduation-cap" title="tutor_channels"></i>
                  <span>家庭教師登録媒体リスト</span>
                  <p class="desc">家庭教師が登録された媒体の一覧です。<br>重複も含めて一覧にしています。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/students/inheritance"><i class="fa fa-fw fa-graduation-cap" title="引継リスト"></i>
                  <span>引継リスト</span>
                  <p class="desc">引継リストです。</p>
                </router-link>
              </template>

            </div>
          </transition>

          <transition name="demo">
            <div class="tile" id="support" v-if="state.support">

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/appointmentsupports"><i class="fa fa-fw fa-file-pdf-o" title="AP対応履歴"></i>
                  <span>AP対応履歴</span>
                  <p class="desc">AP対応履歴の一覧です。</p>
                </router-link>

                <router-link to="/familysupports"><i class="fa fa-fw fa-file-pdf-o" title="家庭対応履歴"></i>
                  <span>家庭対応履歴</span>
                  <p class="desc">家庭対応履歴の一覧です。</p>
                </router-link>

                <router-link to="/tutorsupports"><i class="fa fa-fw fa-file-pdf-o" title="先生対応履歴"></i>
                  <span>先生対応履歴</span>
                  <p class="desc">先生対応履歴の一覧です。</p>
                </router-link>
              </template>

            </div>
          </transition>

          <transition name="demo">
            <div class="tile" id="pdf" v-if="state.pdf">

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/familyfiles"><i class="fa fa-fw fa-file-pdf-o" title="家庭ファイル"></i>
                  <span>家庭ファイル</span>
                  <p class="desc">契約書、口座振替依頼書、<br>などの家庭に関するPDFの一覧です。</p>
                </router-link>

                <router-link to="/studentfiles"><i class="fa fa-fw fa-file-pdf-o" title="生徒ファイル"></i>
                  <span>生徒ファイル</span>
                  <p class="desc">生徒に関するPDFの一覧です。<br>報告書ページができるまでここでの仮。</p>
                </router-link>

                <router-link to="/tutorfiles"><i class="fa fa-fw fa-file-pdf-o" title="先生ファイル"></i>
                  <span>先生ファイル</span>
                  <p class="desc">履歴書、研修資料、<br>などの先生に関するPDFの一覧です。</p>
                </router-link>

                <a href="http://153.126.169.95/student_tutors/search?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="報告書管理"></i>
                  <span>報告書管理</span>
                  <p class="desc">別タブで開きます</p>
                </a>
              </template>

              <template v-if="user.type === 'admin'">
                <!-- <router&#45;link to="/reports"><i class="fa fa&#45;fw fa&#45;file&#45;pdf&#45;o" title="報告書"></i> -->
                <router-link to="/reports"><i class="fa fa-fw fa-exclamation-triangle" title="報告書"></i>
                  <span>報告書</span>
                  <p class="desc">メンテナンス中</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <a href="http://153.126.169.95/student_tutors/?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="指導情報"></i>
                  <span>指導情報</span>
                  <p class="desc">生徒先生の紐付けです</p>
                </a>
              </template>

            </div>
          </transition>

          <transition name="demo">
            <div class="tile" id="other" v-if="state.other">

              <template v-if="user.type === 'admin' || user.office_id === 1">
                <a href="/kenshus"><i class="fa fa-fw fa-leanpub" title="スケジュール"></i>
                  <span>スケジュール</span>
                  <p class="desc">面接、研修の予定を管理します。</p>
                </a>
              </template>

              <template v-if="user.type === 'admin' || user.office_id === 1 || user.office_id === 3">
                <a href="https://neo-print.masterminds.jp/" target="_blank"><i class="fa fa-fw fa-leanpub" title="AP封筒印刷"></i>
                  <span>AP封筒印刷</span>
                  <p class="desc"></p>
                </a>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/student_tutors"><i class="fa fa-fw fa-file-text" title="探しデータ"></i>
                  <span>探しデータ</span>
                  <p class="desc">探しの管理画面です。</p>
                </router-link>

                <router-link to="/documents"><i class="fa fa-fw fa-book" title="documents"></i>
                  <span>documents</span>
                  <p class="desc">documents</p>
                </router-link>

                <router-link to="/tags"><i class="fa fa-fw fa-tags" title="タグリスト"></i>
                  <span>タグリスト</span>
                  <p class="desc">対応履歴に紐づけるタグの管理画面です。<br>削除すると対応履歴のタグも削除されます。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner'">
                <router-link to="/todos"><i class="fa fa-fw fa-check-square" title="Todoリスト"></i>
                  <span>Todoリスト</span>
                  <p class="desc">Todo</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner'">
                <router-link to="/channels"><i class="fa fa-fw fa-graduation-cap" title="教師登録媒体"></i>
                  <span>教師登録媒体</span>
                  <p class="desc">ADMIN / OWNER<br>媒体を管理する画面です。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
                <router-link to="/office_channels"><i class="fa fa-fw fa-graduation-cap" title="教師登録媒体カスタム"></i>
                  <span>教師登録媒体カスタム</span>
                  <p class="desc">ADMIN / OWNER / MGR<br>媒体を管理する画面です。</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin'">
                <router-link to="/appointment_channels"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
                  <span>appointment_channels</span>
                  <p class="desc">メンテナンス中</p>
                </router-link>
              </template>

              <router-link to="/versions"><i class="fa fa-fw fa-history" title="変更履歴"></i>
                <span>変更履歴</span>
                <p class="desc">変更履歴</p>
              </router-link>

            </div>
          </transition>

          <transition name="demo">
            <div class="tile" id="aggregate" v-if="state.aggregate">

              <!-- <template v&#45;if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'"> -->
              <router-link to="/aggregates/appointments"><i class="fa fa-fw fa-line-chart" title="集計-AP"></i>
                <span>集計-AP</span>
                <p class="desc">アポの集計画面です。</p>
              </router-link>
              <!-- </template> -->

              <router-link to="/aggregates/appointments_month"><i class="fa fa-fw fa-line-chart" title="集計-月間CV"></i>
                <span>集計-月間CV</span>
                <p class="desc">アポの集計画面です。</p>
              </router-link>

              <router-link to="/aggregates/appointments_month2"><i class="fa fa-fw fa-line-chart" title="集計-月間AP"></i>
                <span>集計-月間AP</span>
                <p class="desc">アポの集計画面です。</p>
              </router-link>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
                <router-link to="/aggregates/tutor_channels"><i class="fa fa-fw fa-line-chart" title="集計-家庭教師"></i>
                  <span>集計-家庭教師</span>
                  <p class="desc">家庭教師の集計画面です。</p>
                </router-link>
              </template>

            </div>
          </transition>

          <transition name="demo">
            <div class="tile" id="keiri" v-if="state.keiri">

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <a href="/contracts"><i class="fa fa-fw fa-money" title="経理"></i>
                  <span>経理</span>
                  <p class="desc">経理管理画面です。<br>ADMIN / OWNER / ACT</p>
                </a>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <router-link to="/contracts"><i class="fa fa-fw fa-money" title="契約情報"></i>
                  <span>契約情報</span>
                  <p class="desc">ADMIN / OWNER / ACT / MGR</p>
                </router-link>
              </template>

              <!-- 526.平松大 377.下田かおり 75.鈴木庬 620.穂積一郎 653.草谷勇介 627.福田匠 612.三木佑馬 520.宮崎衣未 121.嶽間澤稜来 -->
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting' || user.id === 526 || user.id === 377 || user.id === 75 || user.id === 620 || user.id === 653 || user.id === 627 || user.id === 612 || user.id === 520 || user.id === 121">
                <router-link to="/paymentdetails"><i class="fa fa-fw fa-money" title="テキスト支払"></i>
                  <span>テキスト支払</span>
                  <p class="desc">ADMIN / OWNER / ACT / MGR</p>
                </router-link>
              </template>

              <!-- 526.平松大 377.下田かおり 75.鈴木庬 620.穂積一郎 653.草谷勇介 627.福田匠 612.三木佑馬 520.宮崎衣未 121.嶽間澤稜来 -->
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting' || user.id === 526 || user.id === 377 || user.id === 75 || user.id === 620 || user.id === 653 || user.id === 627 || user.id === 612 || user.id === 520 || user.id === 121">
                <router-link to="/paymentdetails2s"><i class="fa fa-fw fa-money" title="管理費支払"></i>
                  <span>管理費支払</span>
                  <p class="desc">ADMIN / OWNER / ACT / MGR</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'accounting'">
                <router-link to="/aggregates/contracts_month"><i class="fa fa-fw fa-line-chart" title="集計-月間売上"></i>
                  <span>集計-月間売上</span>
                  <p class="desc">月間売上の集計画面です。<br>ADMIN / OWNER</p>
                </router-link>

                <router-link to="/aggregates/contracts"><i class="fa fa-fw fa-line-chart" title="集計-売上"></i>
                  <span>集計-売上</span>
                  <p class="desc">売上の集計画面です。<br>ADMIN / OWNER</p>
                </router-link>

                <router-link to="/aggregates/paymentdetails"><i class="fa fa-fw fa-line-chart" title="集計-自社割賦"></i>
                  <span>集計-自社割賦</span>
                  <p class="desc">自社割賦の集計画面です。<br>ADMIN / OWNER</p>
                </router-link>
              </template>

              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'accounting' || user.type === 'mgr'">
                <router-link to="/aggregates/agreements"><i class="fa fa-fw fa-line-chart" title="集計-売上-販売価格"></i>
                  <span>集計-売上-販売価格</span>
                  <p class="desc">売上の集計画面です。<br>ADMIN / OWNER / MGR</p>
                </router-link>
              </template>

            </div>
          </transition>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
// lottie
import * as animationData from '../../../assets/techno_penguin.json'

export default {
  props: {
    dtp: Object
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  data () {
    return {
      defaultOptions: {animationData: animationData},
      animationSpeed: 1,

      state: {
        regist: true,
        list: true,
        support: true,
        pdf: true,
        aggregate: true,
        keiri: true,
        other: true
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  methods: {
    all () {
      this.state.regist = true
      this.state.list = true
      this.state.support = true
      this.state.pdf = true
      this.state.aggregate = true
      this.state.keiri = true
      this.state.other = true
    },

    regist () {
      this.state.regist = true
      this.state.list = false
      this.state.support = false
      this.state.pdf = false
      this.state.aggregate = false
      this.state.keiri = false
      this.state.other = false
      // document.getElementById('regist').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // })
    },

    list () {
      this.state.regist = false
      this.state.list = true
      this.state.support = false
      this.state.pdf = false
      this.state.aggregate = false
      this.state.keiri = false
      this.state.other = false
      // document.getElementById('list').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // })
    },

    support () {
      this.state.regist = false
      this.state.list = false
      this.state.support = true
      this.state.pdf = false
      this.state.aggregate = false
      this.state.keiri = false
      this.state.other = false
      // document.getElementById('support').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // })
    },

    pdf () {
      this.state.regist = false
      this.state.list = false
      this.state.support = false
      this.state.pdf = true
      this.state.aggregate = false
      this.state.keiri = false
      this.state.other = false
      // document.getElementById('pdf').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // })
    },

    aggregate () {
      this.state.regist = false
      this.state.list = false
      this.state.support = false
      this.state.pdf = false
      this.state.aggregate = true
      this.state.keiri = false
      this.state.other = false
      // document.getElementById('aggregate').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // })
    },

    keiri () {
      this.state.regist = false
      this.state.list = false
      this.state.support = false
      this.state.pdf = false
      this.state.aggregate = false
      this.state.keiri = true
      this.state.other = false
      // document.getElementById('keiri').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // })
    },

    other () {
      this.state.regist = false
      this.state.list = false
      this.state.support = false
      this.state.pdf = false
      this.state.aggregate = false
      this.state.keiri = false
      this.state.other = true
      // document.getElementById('other').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // })
    },

    handleAnimation (anim) {
      this.anim = anim
    },

    stop () {
      this.anim.stop()
    },

    play () {
      this.anim.play()
    },

    pause () {
      this.anim.pause()
    },

    onSpeedChange () {
      this.anim.setSpeed(this.animationSpeed)
    }
  },
  route: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.Index {
  .multiselect__tags {
    padding: 0 40px 0 0;
    min-height: initial;
  }
}
</style>
<style lang="scss" scoped>
.demo-enter-active, .demo-leave-active {
  transition: transform .5s, opacity .5s;
}
.demo-move:not(.demo-leave-active) {
  transition: transform .5s;
}
/* 表示される時は上からスライド */
.demo-enter {
  opacity: 0;
  transform: translateY(-20px);
  /* transform: scale(0.8); */
}
/* 消える時は縮小される */
.demo-leave-to {
  opacity: 0;
  /* transform: translateY(-20px); */
  transform: scale(0.8);
}
.demo-leave-active {
  position: absolute;
}

.wrapper {
  .category {
    margin-top: 5px;
    display: flex;
    .category-btn {
      position: relative;
      // display: table;
      font-size: 14px;
      font-weight: bold;
      background: #36474f;
      color: #fff;
      text-align: center;
      border-radius: 25px;
      padding: .75em;
      margin: 5px;
      width: 130px;
      box-shadow: 0 2px 2px rgba(0,0,0,.24), 0 0 2px rgba(0,0,0,.12);
      text-decoration: none;
      transition: all .3s;
      &:hover {
        box-shadow: 0 4px 4px rgba(1,67,163,.24), 0 0 4px rgba(1,67,163,.12), 0 6px 18px rgba(43,133,231,.12);
        cursor: pointer;
        transform: translate3d(0,-2px,0);
      }
      i {
        positon: absolute;
        top: 11px;
        right: 10px;
        margin-left: 5px;
        position: absolute;
        font-size: 16px;
      }
      /* .title { */
      /*   color: #3ab981; */
      /*   // color: #039be5; */
      /*   font-weight: bold; */
      /* } */
      /* .desc { */
      /*   padding: 0 0 0 5px; */
      /*   font-size: 11px; */
      /*   line-height: 1.5; */
      /* } */
    }
  }
  .tile-box {
    margin-top: 5px;
    overflow: auto;
    height: calc(100vh - 150px);
    .tile {
      /* margin-top: 15px; */
      display: flex;
      flex-flow: row wrap;
      a {
        background: #fff;
        font-size: 17px;
        color: #637d88;
        margin: 5px;
        width: 100%;
        max-width: 280px;
        height: 100px;
        box-shadow: 0 2px 2px rgba(0,0,0,.24), 0 0 2px rgba(0,0,0,.12);
        text-decoration: none;
        text-align: center;
        padding: 20px 5px 0;
        transition: all .3s;
        &:hover {
          box-shadow: 0 4px 4px rgba(1,67,163,.24), 0 0 4px rgba(1,67,163,.12), 0 6px 18px rgba(43,133,231,.12);
          cursor: pointer;
          transform: translate3d(0,-2px,0);
          /* background: #263238; */
          /* color: #fff; */
        }
        i {
          color: #039be5;
          margin-right: 5px;
          margin-left: -20px;
          font-size: 17px;
        }
        .desc {
          font-size: 11px;
          line-height: 1.5;
        }
      }
    }
  }
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// Index.vue?4ac25182